var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BField',[_c('div',{staticClass:"control is-clearfix"},[_c('input',{staticClass:"input",class:{ 'input--clamped': _vm.clamped },attrs:{"type":"number","step":"1","disabled":_vm.$attrs.disabled},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }